// import { createContext, useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api, { initializeTokenRefresh } from "../axiosConfig";
// import {
//   getToken,
//   getRefreshToken,
//   saveTokens,
//   clearAuth,
//   setTokenExpiry,
// } from "../services/useAuth";
// import { getJwtExpiry } from "../utils/jwt";

// const AuthContext = createContext();

// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const login = async (payload) => {
//     const res = await api.post("/api/login", payload);

//     const { access_token, refresh_token, employee_data, dashboard_access } = res.data;

//     saveTokens({ access_token, refresh_token });
//     setTokenExpiry(getJwtExpiry(access_token));

//     localStorage.setItem("userId", employee_data.id);
//     localStorage.setItem("username", payload.username);
//     localStorage.setItem("dashboard_access", JSON.stringify(dashboard_access));

//     setUser({
//       id: employee_data.id,
//       username: payload.username,
//       dashboardAccess: dashboard_access,
//     });

//     setTimeout(initializeTokenRefresh, 500);
//   };

// const logout = async () => {
//   try {
//     await api.post("/api/logout");
//   } catch (err) {
//     console.warn("Logout API failed (ignored):", err.message);
//   } finally {
//     clearAuth();
//     setUser(null);
//     navigate("/login", { replace: true });
//   }
// };


//   useEffect(() => {
//     const token = getToken();
//     const refresh = getRefreshToken();
//     const userId = localStorage.getItem("userId");

//     if (!token || !refresh || !userId) {
//       setLoading(false);
//       return;
//     }

//     setUser({
//       id: Number(userId),
//       username: localStorage.getItem("username"),
//       dashboardAccess: JSON.parse(localStorage.getItem("dashboard_access") || "{}"),
//     });

//     initializeTokenRefresh();
//     setLoading(false);
//   }, []);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         login,
//         logout,
//         loading,
//         isAuthenticated: !!user,
//         hasAccess: (k) => user?.dashboardAccess?.[k] === true,
//       }}
//     >
//       {!loading && children}
//     </AuthContext.Provider>
//   );
// }

// export const useAuth = () => useContext(AuthContext);


import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { initializeTokenRefresh } from "../axiosConfig";
import {
  getToken,
  getRefreshToken,
  saveTokens,
  clearAuth,
  setTokenExpiry,
} from "../services/useAuth";
import { getJwtExpiry } from "../utils/jwt";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const login = async (payload) => {
    const res = await api.post("/api/login", payload);

    const { access_token, refresh_token, employee_data, dashboard_access, role } = res.data;

    saveTokens({ access_token, refresh_token });
    setTokenExpiry(getJwtExpiry(access_token));

    localStorage.setItem("userId", employee_data.id);
    localStorage.setItem("username", payload.username);
    localStorage.setItem("dashboard_access", JSON.stringify(dashboard_access));
    localStorage.setItem("role", role);

    setUser({
      id: employee_data.id,
      username: payload.username,
      dashboardAccess: dashboard_access,
      dashboard_access: dashboard_access,
      role: role,
      employee_data: employee_data,
    });

    setTimeout(initializeTokenRefresh, 500);
  };

  const logout = async () => {
    try {
      await api.post("/api/logout");
    } catch (err) {
      console.warn("Logout API failed (ignored):", err.message);
    } finally {
      clearAuth();
      setUser(null);
      navigate("/login", { replace: true });
    }
  };

  useEffect(() => {
    const token = getToken();
    const refresh = getRefreshToken();
    const userId = localStorage.getItem("userId");

    if (!token || !refresh || !userId) {
      setLoading(false);
      return;
    }

    setUser({
  id: Number(userId),
  username: localStorage.getItem("username"),
  dashboardAccess: JSON.parse(localStorage.getItem("dashboard_access") || "{}"),
  dashboard_access: JSON.parse(localStorage.getItem("dashboard_access") || "{}"),
  role: localStorage.getItem("role") || localStorage.getItem("userRole"), // ← add userRole fallback
});

    initializeTokenRefresh();
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
        isAuthenticated: !!user,
        hasAccess: (k) => user?.dashboardAccess?.[k] === true,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);